import React from 'react';
import { Button, Grid } from '@mui/material';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { DisplayStringTrans, useTranslation } from '@gamiphy/react-i18n';
import { OnboardingAnalytics } from '@gamiphy/loyalty-station-desktop/store/analytics';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { IntegrationsStore } from '@gamiphy/loyalty-station-desktop/store/integrations';
import { SdkStore } from '@gamiphy/loyalty-station-desktop/store/sdk';
import { DisplayString } from '@gamiphy/i18n';

const Actions: React.FC = () => {
  const { t } = useTranslation();

  const onJoin = async () => {
    if (!UserStore.isLoggedIn) {
      await UserStore.registerDraftUser();
    }
    OnboardingAnalytics.trackStarted();
    OnboardingAnalytics.joinNowClicked();
  };

  const onSignIn = () => {
    void SdkStore.goToAuth(false);
    UiStore.autoOpen();
    OnboardingAnalytics.trackSignInClicked();
    void IntegrationsStore.trackGTMEvent({
      category: 'welcomePage',
      action: 'loginClicked',
    });
  };

  return (
    <Grid container spacing={2} sx={{ padding: (theme) => theme.spacing(0.5, 2) }}>
      <Grid size={12}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            padding: (theme) => theme.spacing(1.5, 4),
            boxShadow: '0 5px 10px 0 rgba(0, 0, 0, 0.05)',
            width: 'fit-content',
            margin: '0 auto',
            display: 'block',
            textAlign: 'center',
            borderRadius: '8px',
            fontSize: '1.2rem',
            lineHeight: '1.5rem',
            fontWeight: 500,
            textTransform: 'capitalize',
          }}
          onClick={() => {
            void onJoin();
            void IntegrationsStore.trackGTMEvent({
              category: 'welcomePage',
              action: 'signupClicked',
            });
          }}
        >
          <DisplayStringTrans displayString={ThemeStore.theme?.onboarding.landing?.button as DisplayString} />
        </Button>
      </Grid>
      <Grid size={12}>
        <Grid container direction="row" justifyContent="center">
          <Grid sx={{ fontSize: '1.2rem', fontWeight: 400 }}>
            {t('shared.alreadyMember', { defaultValue: 'Already a member? ' })}
          </Grid>
          <Grid
            sx={{
              textDecoration: 'underline',
              textUnderlineOffset: '1px',
              color: (theme) => theme.palette.primary.main,
              cursor: 'pointer',
              fontSize: '1.2rem',
              fontWeight: 600,
              marginInlineStart: '4px',
            }}
            onClick={onSignIn}
          >
            {t('shared.signIn', { defaultValue: 'Sign In' })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Actions;
